export default "/assets/images/rookie-hero.a68dde9a0c488a34.png";